function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-1215-4814H225v6638h-1440z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 29,
  x: 0.5,
  y: 0.5,
  stroke: "#DEDEDE",
  rx: 14.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A4A2A8",
  fillRule: "nonzero",
  d: "M15.75 14.25h4.5a.75.75 0 110 1.5h-4.5v4.5a.75.75 0 11-1.5 0v-4.5h-4.5a.75.75 0 010-1.5h4.5v-4.5a.75.75 0 011.5 0v4.5z"
})));

var SvgFaqOpen = function SvgFaqOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjE1IC00ODE0KSI+CiAgICA8cmVjdCB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI2NjM4IiBmaWxsPSIjRkZGRkZGIi8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjE1IDQ4MTQpIj4KICAgICAgPHJlY3Qgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiB4PSIuNSIgeT0iLjUiIHN0cm9rZT0iI0RFREVERSIgcng9IjE0LjUiLz4KICAgICAgPHBhdGggZmlsbD0iI0E0QTJBOCIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNNi43NSw1LjI1IEwxMS4yNSw1LjI1IEMxMS42NjQyMTM2LDUuMjUgMTIsNS41ODU3ODY0NCAxMiw2IEMxMiw2LjQxNDIxMzU2IDExLjY2NDIxMzYsNi43NSAxMS4yNSw2Ljc1IEw2Ljc1LDYuNzUgTDYuNzUsMTEuMjUgQzYuNzUsMTEuNjY0MjEzNiA2LjQxNDIxMzU2LDEyIDYsMTIgQzUuNTg1Nzg2NDQsMTIgNS4yNSwxMS42NjQyMTM2IDUuMjUsMTEuMjUgTDUuMjUsNi43NSBMMC43NSw2Ljc1IEMwLjMzNTc4NjQzOCw2Ljc1IDAsNi40MTQyMTM1NiAwLDYgQzAsNS41ODU3ODY0NCAwLjMzNTc4NjQzOCw1LjI1IDAuNzUsNS4yNSBMNS4yNSw1LjI1IEw1LjI1LDAuNzUgQzUuMjUsMC4zMzU3ODY0MzggNS41ODU3ODY0NCwwIDYsMCBDNi40MTQyMTM1NiwwIDYuNzUsMC4zMzU3ODY0MzggNi43NSwwLjc1IEw2Ljc1LDUuMjUgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOSA5KSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgFaqOpen as ReactComponent };